import { Button } from '@sede-enterprise/shell-ds-react-framework';
import { ErrorStateContentBox } from 'components/ErrorStates/ErrorStateContentBox/ErrorStateContentBox';
import { useNavigate } from 'react-router';

export const SitesFetchingErrorState = () => {
  const navigate = useNavigate();

  return (
    <ErrorStateContentBox
      headingText={'There’s an issue on our end'}
      subText={
        <>
          <div>This company does not contain any sites.</div>
          <div>Please select another company.</div>
        </>
      }
      actions={
        <div>
          <Button
            style={{ marginRight: 12 }}
            onClick={() => window.location.reload()}
            variant={'outlined'}
          >
            Reload this page
          </Button>
          <Button onClick={() => navigate('/')}>Select a company</Button>
        </div>
      }
    />
  );
};
